import {createAsyncThunk} from "@reduxjs/toolkit";
import {client} from "../../_api/client";

export const TRAINING = "training";

export const getTrainingHistory = createAsyncThunk(
    `${TRAINING}/getTrainingHistory`,
    async () => {
        const response = await client.post('/task/getTrainingHistory', {})
        return response.data
    }
)